import { render, staticRenderFns } from "./gift-card-invitation-list.vue?vue&type=template&id=39e9d0bc&scoped=true&lang=html&"
import script from "./gift-card-invitation-list.vue?vue&type=script&lang=js&"
export * from "./gift-card-invitation-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e9d0bc",
  null
  
)

export default component.exports